const MOBILE_BACKGROUND_VIDEO_HEIGHT = 680;

export { MOBILE_BACKGROUND_VIDEO_HEIGHT };
